var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttonCss"},[_c('Button',{attrs:{"name":_vm.name,"type":"fill","action":"onClick","active":_vm.active},on:{"onClick":_vm.toggle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }